import { ButtonType, ButtonWidget, Tooltip } from '@tableau/widgets';
import React from 'react';

import { EditDatasourceEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/EditDatasourceEntityAction';
import { isUsingBridge } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';

import { Messages } from '../../codegen/Localize';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';
import { IDataSourceDetailInfo } from '../models/IDataSourceInfo';
import { IDatasourceActions } from '../ServerApi/types/IDatasourceActions';
import { openEditConfirmDialog } from './DatasourceEditConfirmDialog';


export function createEditDataSourceButton(params: {
  readonly item: IContentInfo<'datasource'>;
  readonly actions: IDatasourceActions;
  readonly editDatasource: () => void;
  readonly hasAssociatedFlows: boolean;
}): JSX.Element {
  const editDatasourceAction = EditDatasourceEntityAction;
  const itemList = [ params.item ];
  if (editDatasourceAction.isVisible(itemList, null, params.actions)) {
    return <EditDataSourceButtonWrapper {...params} />;
  }
}

function EditDataSourceButtonWrapper(props: {
  readonly item: IContentInfo<'datasource'>;
  readonly actions: IDatasourceActions;
  readonly editDatasource: () => void;
  readonly hasAssociatedFlows: boolean;
}): React.ReactElement {
  const editDataSourceButtonRef = React.useRef<HTMLButtonElement>(null);

  const editDatasourceAction = EditDatasourceEntityAction;
  const itemList = [ props.item ];
  const isDisabled = !editDatasourceAction.isClickable(props.actions, itemList, null);
  const isBridge = isDisabled && isUsingBridge(props.item as IDataSourceDetailInfo);

  const handleEditDatasource = () => {
    if (props.hasAssociatedFlows) {
      // The datasource page has prep flow information already.
      // Let's use it to display the warning, and not fetch them again.
      openEditConfirmDialog(editDataSourceButtonRef.current)
        .then(props.editDatasource);
    }
    else {
      props.editDatasource();
    }
  };

  return (<>
    <ButtonWidget
      buttonRef={editDataSourceButtonRef}
      children={Messages.editDatasource()}
      buttonType={ButtonType.Outline}
      handleClick={handleEditDatasource}
      testId={'action-edit-datasource'}
      disabled={isDisabled} />
    {isBridge && <Tooltip testId={'edit-datasource-tooltip'} getContent={() =>
      <span>{Messages.errorEditDatasourceDisabledForBridge()}</span>} />}
  </>);
}
